import React, { useContext } from "react";
import StackedBarChart from "../../components/Graph/Barchart/StackedBarChart";
import IssueBarLineChart from "../../components/Graph/Barchart/IssueBarLineChart";
import CustomerMeetingTable from "../../components/Table/CustomerMeetingTable";
import { axInstBasic } from "../../components/Service/Service";
import { useQuery } from "@tanstack/react-query";
import { FilterContext } from "../../context/Filter";

// API fetch function
const fetchIssueStatus = async (parArn, childArn) => {
  try {
    const res = await axInstBasic.post(
      `${process.env.REACT_APP_API_URL}issue-status`,
      { parArn, childArn }
    );
    return res.data.result;
  } catch (error) {
    console.error("Error fetching issue status:", error);
    throw error;
  }
};

const IssueStatus = () => {
  // const urlParams = new URLSearchParams(window.location.search);
  // const parArn = urlParams.get("arn");
  // const childArn = urlParams.get("childArn");
  const { superArn: parArn, childArn } = useContext(FilterContext);
  // console.log("ParArn", parArn, "ChildArn", childArn);
  const { open } = useContext(FilterContext)


  const {
    data: issueStatusData,
    isLoading,
    isError,
  } = useQuery({
    queryKey: ["getIssueStatus", parArn, childArn],
    queryFn: () => fetchIssueStatus(parArn, childArn),
    enabled: !!parArn || !!childArn, // Only run if at least one is present
  });

  const stackedGraphData = issueStatusData?.find(
    (item) => item.points_categories_by_disscussion_type
  )?.points_categories_by_disscussion_type;

  const issueBarLineChart = issueStatusData?.find(
    (item) => item.mom_points_trend_analysis
  )?.mom_points_trend_analysis;

  const momTableValues = issueStatusData?.find(
    (item) => item.mom_table?.buckets
  )?.mom_table?.buckets;
  //  console.log("Mom Table Values", momTableValues)

  if (isLoading) return <div>Loading...</div>;
  if (isError) return <div>Error fetching issue status</div>;

  return (
    <div
      className={`
    flex flex-col gap-4 pl-2
    w-96
    ${open ? "sm:w-[1050px]" : "sm:w-[1200px]"}
  `}
    >

      {/* // <div className={`w-96 sm:${open ? "w-[1000px]" : "w-[1200px]"} flex flex-col gap-4 pl-2`}> */}
      <div className="border rounded-t-md">
        <p className="p-1 py-1 px-2 bg-[#056DB3] text-white font-bold rounded-t-md ">
          Customer Meeting Tracker
        </p>
        <CustomerMeetingTable momTableValues={momTableValues} />
      </div>
      <p className="w-full p-1 py-1 px-2 bg-[#056DB3] rounded-t-md mt-4  p-2 text-white font-semibold">
        Issue Status
      </p>
      <div className="flex flex-col md:flex-row items-center gap-2">
        <div
          className={`border rounded-t-md w-full h-[400px] ${open ? "md:w-[530px]" : "md:w-1/2"
            }`}
        >
          <p className="text-white p-1 py-1 px-2 bg-[#056DB3]  font-bold rounded-t-md">
            (MOM) Points Categorized by Discussion Type
          </p>
          <StackedBarChart stackedGraphData={stackedGraphData} />
        </div>
        <div
          className={`border rounded-t-md w-full h-[400px] ${open ? "md:w-[450px]" : "md:w-1/2"
            }`}
        >          <p className="text-white p-1 py-1 px-2 bg-[#056DB3] text-white font-bold rounded-t-md">
            MOM Points trend analysis
          </p>
          <IssueBarLineChart issueBarLineChart={issueBarLineChart} />
        </div>
      </div>

    </div>
  );
};

export default IssueStatus;